// extracted by mini-css-extract-plugin
module.exports = {"cardBox":"cardBox_cardBox__22NMI"};